import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemDominiosSubtiposExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => {
      return {
        id: item.id,
        dominioTipo: item.dominioTipo.id,
        status: optionStatusBin[item.status]?.label,
        ordem: item.ordem,
        dominioSubtipo: item.dominioSubtipo,
        descricao: item.descricao,
        cor: item.cor.codigoHexadecimal,
        corText: item.corText === 2 ? 'Branco' : 'Preto',
        observacoes: item.observacoes,
        usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
        nEdicoes: item.nEdicoes || 0,
      };
    });

    const mainSheet: ExportSheet = {
      name: 'Listagem de Subtipos',
      columns: {
        id: 'ID',
        status: 'Status do Subtipo de Domínio',
        ordem: 'Ordem',
        dominioSubtipo: 'Nome do Subtipo de Domínio',
        descricao: 'Descrição',
        cor: 'Cor do Background',
        corText: 'Cor do Texto',
        observacoes: 'Observações',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
